import { unwrap, type WidgetDefinition } from "@nexus/widget-sdk";
import type { EventRestreamingServicesData } from "./types";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "event-restreaming-services",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "One protected event's restreaming pirate services, ranked by audience.",
    domain: "reports",
    visual: "Carousel",
    purposes: ["reporting"],
    reportEdition: true,
    audiences: ["analyst", "client"],
  },
  layout: { skeleton: "cards" },
  // The protected event it covers, within its campaign: the page's subject.
  subjects: (data) => {
    const event = unwrap<EventRestreamingServicesData>(data.services)?.event;
    return event
      ? [
          {
            kind: "protected-event",
            id: event.id,
            label: event.label,
            campaign: event.campaign,
            ...(event.tenant ? { tenant: event.tenant } : {}),
          },
        ]
      : [];
  },
  defaultLayoutClassName: "col-span-12",
};
